import React from 'react'
import { FormControl, FormControlLabel, Checkbox as MUICheckBox } from '@mui/material'
export default function Checkbox(props) {
    const { name, label, value, onChange, ...rest } = props;
    const handleOnChange = (name, value) => ({
        traget: {
            name,
            value
        }
    })
    return (
        <FormControl>
            <FormControlLabel
                control={
                    <MUICheckBox
                        name={name}
                        value={value}
                        onChange={e => onChange(handleOnChange(name, e.target.checked))}
                        color="primary"
                        {...rest}
                    />
                }
                label={label}
            />
        </FormControl>
    )
}
